import { render, staticRenderFns } from "./ProductionParametersTab.vue?vue&type=template&id=fe2d9510&"
import script from "./ProductionParametersTab.vue?vue&type=script&lang=js&"
export * from "./ProductionParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports